'use strict';

angular.module('shiftTraderApp')
  .controller('ModalWeekPublishingCtrl', function($scope, params, $uibModalInstance, TimeService, WorkPeriodStore,
                                                  ServerUrls, WorkPeriods, $http, InternalAnalyticsService,
                                                  WeekCalculationService, toastr, GlobalRxFeed) {
    $scope.org = params.org;
    $scope.currentDate = params.currentDate;
    $scope.weekTwix = TimeService.getWeekTwixFromMoment($scope.currentDate, 0, 0, true);
    $scope.weekTwixFormatted = $scope.weekTwix.start.format('MMM D, YYYY') + ' to ' + moment($scope.weekTwix.end).subtract(1, 'day').format('MMM D, YYYY');
    $scope.activePositionIds = _(params.allPositions).where({active: true}).pluck('id').value();

    $uibModalInstance.rendered.then(function () {
      GlobalRxFeed.push('modal-opened', 'publish-schedule', $uibModalInstance)
    })

    var tempDay;

    $scope.dates = _.map([0,1,2,3,4,5,6], function(num) {
      tempDay = moment($scope.weekTwix.start).add(num, 'days');
      return tempDay;
    });

    $scope.state = {
      numDepartmentsSelected: 0,
      numDaysSelected: 0,
      waitingForPublishResponse: false
    };

    WorkPeriodStore.getWorkPeriodsBetween(moment($scope.weekTwix.start).subtract(1,'days'), moment($scope.weekTwix.start).add(7, 'days'))
        .then(function(wps) {

          $scope.workPeriodOverlapsByDay = _.map($scope.dates, function(dt) {
            var dtTwix = moment(dt).twix(moment(dt).add(1, 'days'));

            return _.where(wps, function(wp) {
              return wp.range_twix.overlaps(dtTwix) &&
                  Math.abs(wp.range_twix.intersection(dtTwix).length('minutes')) > 0 &&
                  _.contains($scope.activePositionIds, wp.position_id); // only allow workPeriods that are in an active position to be published like this
            });
          });

          calculateAllTheNumbers();
          $scope.allDepartments = _.map(_.cloneDeep($scope.org.departments), function(dept) {
            dept._hasShiftsToPublish = _.any($scope.dayAnalysisDataByDay, function(day) {
              return day.departmentData[dept.id].numAssignedUnpublishedWorkPeriodsStartingToday > 0;
            });
            dept._selected = true;
            return dept;
          });

          calculateSummaryData();
        });

    var calculateAllTheNumbers = function() {
      $scope.dayAnalysisDataByDay = WeekCalculationService.calcWeekWorkPeriodStats($scope.dates,
                                                      $scope.workPeriodOverlapsByDay,
                                                      $scope.org.departments, $scope.org);
    };

    var calculateSummaryData = function() {
      var selectedDeptIds = _.pluck(_.where($scope.allDepartments, {_selected: true}), 'id');
      $scope.state.numDepartmentsSelected = selectedDeptIds.length;

      // for each day aggregate the properties over selected departments
      $scope.statsDataByDay = _.map($scope.dayAnalysisDataByDay, function(day, idx) {
        var temp = {};
        temp.id = idx;
        temp.dateTwix = day.dateTwix;
        _.forEach(['numAssignedUnpublishedWorkPeriodsStartingToday', 'numUnassignedUnpublishedWorkPeriodsStartingToday'], function(prop) {
          temp[prop] = _.reduce(_.pick(day.departmentData, selectedDeptIds), function(accum, deptData) {
            return accum + deptData[prop];
          }, 0);
        });

        temp.assignedUnpublishedWorkPeriodsStartingToday = _.uniq(_.flatten(_.pluck(_.pick(day.departmentData, selectedDeptIds), 'assignedUnpublishedWorkPeriodsStartingToday')));
        temp.uniqueEmployeesWorking = _.uniq(_.flatten(_.pluck(_.pick(day.departmentData, selectedDeptIds), 'uniqueEmployeesWorking')));

        if (day._selected && temp.assignedUnpublishedWorkPeriodsStartingToday.length === 0) {
          day._selected = false;
        }
        return temp;
      });

      $scope.selectedWeekStats = {};

      var selectedStatsDays = _.where($scope.statsDataByDay, function(day, idx) {
        return $scope.dayAnalysisDataByDay[idx]._selected;
      });

      $scope.state.numDaysSelected = selectedStatsDays.length;
      $scope.state.allPossibleDaysSelected = $scope.state.numDaysSelected === _.where($scope.statsDataByDay, function(x) {
        return x.numAssignedUnpublishedWorkPeriodsStartingToday > 0;
      }).length;

      _.forEach(['numAssignedUnpublishedWorkPeriodsStartingToday', 'numUnassignedUnpublishedWorkPeriodsStartingToday'], function(prop) {
        $scope.selectedWeekStats[prop] = _.reduce(selectedStatsDays, function(accum, dayData) {
          return accum + dayData[prop];
        }, 0);
      });

      $scope.selectedWeekStats.assignedUnpublishedWorkPeriodsStartingToday = _.uniq(_.flatten(_.pluck(selectedStatsDays, 'assignedUnpublishedWorkPeriodsStartingToday')));
      $scope.selectedWeekStats.uniqueEmployeesWorking = _.uniq(_.flatten(_.pluck(selectedStatsDays, 'uniqueEmployeesWorking')));
    };

    $scope.close = function() {
      $uibModalInstance.dismiss();
    };

    $scope.toggleDepartmentSelection = function(dept) {
      dept._selected = !dept._selected;
      calculateSummaryData();
    };

    $scope.toggleDaySelection = function(dayIndex) {
      $scope.dayAnalysisDataByDay[dayIndex]._selected = !$scope.dayAnalysisDataByDay[dayIndex]._selected;
      calculateSummaryData();
    };

    $scope.selectAllDays = function() {
      _.forEach($scope.dayAnalysisDataByDay, function(day) {
        day._selected = true;
      });
      calculateSummaryData();
    };

    $scope.deselectAllDays = function() {
      _.forEach($scope.dayAnalysisDataByDay, function(day) {
        day._selected = false;
      });
      calculateSummaryData();
    };

    $scope.closeAndPublish = function() {
      if ($scope.state.waitingForPublishResponse) {
        return
      }

      $scope.state.waitingForPublishResponse = true;
      var data = {
        organization_id: $scope.org.id,
        start_time: $scope.weekTwix.start.toISOString(),
        end_time: $scope.weekTwix.end.toISOString(),
        work_period_ids: _.uniq($scope.selectedWeekStats.assignedUnpublishedWorkPeriodsStartingToday)
      };

      $http.post(ServerUrls.current.railsApi + 'work_periods/bulk_publish', data).then(function (response) {
        var publishedWorkPeriods = _.map(response.data, function(wp) {
          return WorkPeriods.initWithData(wp);
        });
        _.each(publishedWorkPeriods, function(wp) {
          WorkPeriodStore.mergeById(wp);
        });

        toastr.success(publishedWorkPeriods.length + ' shifts published!', 'Success');
        // send off some data to the analytics backend
        if (publishedWorkPeriods.length > 0) {
          var sortedWorkPeriods = _.sortBy(publishedWorkPeriods, function(pwp) {
            return pwp.start_time.unix();
          });

          var selectedDeptIds = _.pluck(_.where($scope.allDepartments, {_selected: true, _hasShiftsToPublish: true}), 'id');

          var dayMapping = {};
          _.each($scope.statsDataByDay, function(day, idx) {
            dayMapping[day.dateTwix.start.day()] = $scope.dayAnalysisDataByDay[idx]._selected ? day.numAssignedUnpublishedWorkPeriodsStartingToday : 0;
          });

          InternalAnalyticsService.captureAnalytic('publish_work_periods:week', {
            _v: 1,
            _d: {
              num_published: publishedWorkPeriods.length,
              num_published_by_day: dayMapping,
              first_work_period_start: sortedWorkPeriods[0].start_time.format(),
              last_work_period_start: _.last(sortedWorkPeriods).start_time.format(),
              department_ids: selectedDeptIds
            }
          });

        }

        $uibModalInstance.close(publishedWorkPeriods);
      }, function() {
        $scope.state.waitingForPublishResponse = false;
        toastr.error('So sorry! We had an issue publishing your schedule. Please try publishing by day.', 'Error');
      });

    };


    $scope.isSomethingSelected = function() {
      return $scope.selectedWeekStats.numAssignedUnpublishedWorkPeriodsStartingToday > 0;
    };

  });
